import * as analytics from 'analytics/Analytics';
import {EventConstants} from 'constants/EventConstants';
import {SECTIONS} from 'constants/NavConstants';
import * as FileBrowserDAO from 'file-browser/FileBrowserDAO';
import AppDispatcher from 'lib/Dispatcher';
import * as FullScreenActions from 'nav/full-screen/FullScreenActions';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import notifications from 'notifications';
import {REGISTRY_ACTIVATION_WELCOME} from 'onboarding/registry-activation-flow/RegistryActivationFlowConstants';
import preferences from 'Preferences';
import * as RegistryDAO from 'registry/RegistryDAO';
import {RegistryPreferences} from 'constants/RegistryConstants';

export function showScreen(screen) {
  FullScreenActions.showScreen(screen);
}

export function setIsLoading() {
  AppDispatcher.dispatch({actionType: EventConstants.REGISTRY_ACTIVATION_SET_IS_LOADING});
}

export function showStartingScreen(origin) {
  showScreen(REGISTRY_ACTIVATION_WELCOME);
  analytics.track('registry_activation', 'began_flow', {origin});
}

export function setOrganization(organization) {
  AppDispatcher.dispatch({
    actionType: EventConstants.REGISTRY_ACTIVATION_SET_ORGANIZATION,
    organization,
  });
}

export function completeRegistryActivation(existingRegistry) {
  analytics.track('registry_activation', 'activation_completed', {existing_registry: existingRegistry});
  preferences.set(RegistryPreferences.REGISTRY_ACTIVATION_COMPLETE, true);
}

export function createRegistry(organizationId) {
  RegistryDAO.create(organizationId)
    .done(() => {
      FileBrowserDAO.fetchSources()
        .done((response) => {
          const sources = response.data;
          AppDispatcher.dispatch({
            actionType: EventConstants.FILE_BROWSER_SOURCES_FETCHED,
            sources,
          });
          completeRegistryActivation(false);
          SidepanelActions.openSection(SECTIONS.REGISTRIES);
        })
        .fail((response) => {
          notifications.notifyError(response);
        });
    })
    .fail((response) => {
      notifications.notifyError(response);
    });
}
